/**
 * Recruit DownloadPopupList - Thin wrapper around the shared framework component.
 * Injects Recruit-specific useSocket and sendData dependencies.
 */
import React from "react";
import UDownloadPopupList from "ubs-framework/v2/UDownloadPopupList";
import {sendData} from "../../../../store/actions";
import {useSelector} from "react-redux";
import useSocket from "../../hooks/useSocket";

const DownloadPopupList = (props) => {
    const _ID = useSelector(e => e?.common?._id);
    return (
        <UDownloadPopupList
            {...props}
            useSocket={useSocket}
            sendData={sendData}
            extraFilter={{productType: 3}}
            userId={_ID}
        />
    );
}

export default DownloadPopupList;
